import { render, staticRenderFns } from "./iconMenu5.vue?vue&type=template&id=7b6f313e&scoped=true&"
import script from "./iconMenu5.vue?vue&type=script&lang=js&"
export * from "./iconMenu5.vue?vue&type=script&lang=js&"
import style0 from "./iconMenu5.vue?vue&type=style&index=0&id=7b6f313e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f313e",
  null
  
)

export default component.exports